import React from 'react';
import { CheckIcon, PillIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, productBrand, productEdition } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access'];
export function FinalCta() {
  return <section className="border-t border-gray-200 bg-navy py-16 sm:py-20" aria-labelledby="final-title" data-id="element-61" data-mp="15ddi58xonvj0">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-62" data-mp="1jcvafya6tqx4">
        <h2 id="final-title" className="text-balance text-3xl font-bold tracking-tight text-pearl sm:text-4xl" data-id="element-63" data-mp="1jbahgd3iug1d">
          <span className="inline-flex items-center gap-2" data-id="element-64" data-mp="1ebxu7r8qn6y9">
            <PillIcon className="h-8 w-8 shrink-0 text-gold" aria-hidden="true" data-id="element-65" data-mp="1t1wsdu0amidq" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-semibold text-gold sm:text-2xl" data-id="element-66" data-mp="1o4ddqszoo3l9">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-pearl/80" data-id="element-67" data-mp="1x4joi73zypgq">
          Created for pharmaceutical production, quality, validation, engineering and maintenance professionals worldwide.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" trackCheckout arrow className="mt-8 w-full sm:w-auto" data-id="element-68" data-mp="s45ts71gznwc">
          Get my professional edition now
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-pearl/80" data-id="element-69" data-mp="123ejuot7sidf">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-70" data-mp="163p1wzua6z8n">
              <CheckIcon className="h-4 w-4 text-aqua-light" aria-hidden="true" data-id="element-71" data-mp="1b2rvno4t9j1b" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}